riot.tag2('animated-spinner', '<div class="spinner-curtain {\'is-show\': opts.showSpinner}" if="{opts.curtain}"></div> <div class="spinner {\'is-show\': opts.showSpinner}{opts.position? \' spinner--\' + opts.position : \'\'}"></div>', '', '', function(opts) {
});
